<template>
    <div v-loading="pageLoading" class="portlet" style="padding-left: 220px;">
    <form class="content" id="myform" method="post" novalidate="novalidate">
    <div class="form-body" style="margin-left:180px">
      <div class="form-group">
        <label class="control-label">手机号：</label>
        <input v-model="phone" class="input-large" type="text" autocomplete="off" placeholder="手机号" name="data[username]">
      </div>
      <div class="form-group">
        <label class="control-label">新密码：</label>
        <input v-model="password" class="input-large" type="password" autocomplete="off" placeholder="8位字母数字" name="data[password]">
      </div>
      <vue-simple-verify style="margin: 10px 33px;" ref="verify" @success="success" />
      <div class="form-group ext">
        <label class="control-label">验证码：</label>
        <input v-model="verCode" class="input-large ext-input" type="text" autocomplete="off" placeholder="手机验证码">
        <div v-loading="buttonLoading" class="get-code" @click="getCode">{{codeTxt}}</div>
      </div>
      <div class="sure-btn" style="margin-top:30px;" @click="next">确 定
      </div>
      </div>
    </form>
  </div>
</template>
<script>
import VueSimpleVerify from 'vue-simple-verify'
import 'vue-simple-verify/dist/vue-simple-verify.css'

export default {
    components:{
        'vue-simple-verify':VueSimpleVerify
    },
    data() {
      return {
        phone:'',
        hasDrag: false,
        verCode:'',
        password:'',
        codeTxt:'获取验证码',
        buttonLoading: false,
        pageLoading: false,
      }
    },
    methods: {
        async next(){
          // this.$emit('changeStep',5);
          // this.$emit('changeStep',{val:5,temToken:123});
          if(!this.validataItem('phone')){
            return false;
          }else if(!this.validataItem('password')){
            return false;
          }else if(!this.validataItem('verCode')){
            return false;
          }
          this.pageLoading = true;
          try {
            const res = await this.$http.post('/api/user/resetpwd',{
              mobile:this.phone,
              captcha:this.verCode,
              newpassword:this.password
              })
            this.pageLoading = false;
            if(res){
                this.$toast('重置密码成功');
                const tem = setTimeout(() => {
                    window.location.href = "/login";
                    clearTimeout(tem);
                }, 1500);
            }
          } catch (error) {
            this.pageLoading = false;
            this.$toast(error.message||'请求失败');
          }
          
        },
        success(){
          this.hasDrag = true;
        },
        validataItem(type){
          if(type === 'phone'){
            const myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            const phone = this.phone;
            if(phone===''){
                this.$toast('请输入手机号')
                return false;
            }else if(!myreg.test(phone)){
                this.$toast('请输入正确的手机号')
                return false;
            }else{
                return true;
            }
          }else if(type === 'password'){
            if(this.password===''){
                this.$toast('请输入重置密码');
                return false;
            }else{
                return true;
            }
          }else{
            if(this.verCode===''){
                this.$toast('请输入验证码');
                return false;
            }else{
                return true;
            }
          }
          
        },
        async getCode(){
          const phone = this.phone;
          if(this.codeTxt !== '获取验证码'){
            return false;
          }
          if(!this.validataItem('phone')){
                return false;
            }else if(!this.hasDrag){
                this.$toast('请按住上方滑块，拖动到最右边');
                return false;
            }
            this.buttonLoading = true;
            try {
              const res = await this.$http.post('/api/user/sendMsg',{phone})
              this.buttonLoading = false;
              if(res){
                this.codeTxt = '60s';
                let count = 60;
                const temInterval = setInterval(() => {
                  count --;
                  this.codeTxt = `${count}s`;
                  if(this.codeTxt === '0s'){
                    clearInterval(temInterval);
                    this.codeTxt = '获取验证码'
                  }
                }, 1000);
              }
            } catch (error) {
              this.buttonLoading = false;
              this.$toast(error.message||'请求失败');
            }
            
        },
    },
    
}
</script>
<style lang="scss" scoped>
@import '../../assets/user.scss';
.ext{
    position: relative;
    .ext-input{
        // width:80px;
    }
    .get-code{
        cursor: pointer;
        position: absolute;
        right: 188px;
        top: 18px;
        width: 85px;
        padding: 8px 0px;
        text-align: center;
        background: #002c56;
        color: #fff;
        font-size: 13px;
    }
}
.sure-btn{
    padding: 9px 24px;
    display: inline-block;
    margin-left: 102px;
    margin-top: 52px;
    cursor: pointer;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.45px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    background: #A4204F;
}
</style>
